import React from "react";
import { LuTrendingUp, LuBuilding2, LuIndianRupee, LuRotateCw } from "react-icons/lu";

export const formatCurrency = (n) => {
  const num = Number(n || 0);
  return `₹${num.toLocaleString("en-IN")}`;
};

export const formatCompact = (n) => {
  const num = Number(n || 0);
  if (num >= 1e7) return `₹${(num / 1e7).toFixed(2)}Cr`;
  if (num >= 1e6) return `₹${(num / 1e6).toFixed(1)}M`;
  if (num >= 1e3) return `₹${(num / 1e3).toFixed(1)}k`;
  return `₹${num.toLocaleString("en-IN")}`;
};

export default function KpiCards({
  kpis = {},
  totalOrganizations = 0,
  totalDealValue = 0,
  totalDeals = 0,
  renewalRevenue = 0,
  userCount = 0,
  selectedUserName = null,
  loading = false,
}) {
  const expectedRevenue = kpis?.expected_revenue ?? 0;
  const orgCount = kpis?.total_organizations ?? totalOrganizations;
  const dealValueDisplay = formatCurrency(totalDealValue);
  const revRevenue = kpis?.renewal_revenue ?? renewalRevenue ?? 0;
  const qualifiedCount = kpis?.qualified_leads ?? 0;
  const dealsCount = kpis?.total_deals ?? totalDeals ?? 0;

  const renewalSub =
    kpis?.total_renewals !== undefined
      ? `Total Renewals: ${kpis.total_renewals}`
      : kpis?.renewals_due_30_days !== undefined
      ? `${kpis.renewals_due_30_days} due in 30 days`
      : "Upcoming contract renewals";

  const cards = [
    {
      title: "Expected Revenue",
      val: formatCurrency(expectedRevenue),
      icon: <LuTrendingUp />,
      bg: "#fffbeb",
      color: "#d97706",
      sub: `Qualified Leads: ${qualifiedCount}`,
      testId: "kpi-expected-revenue",
    },
    {
      title: "Organizations",
      val: orgCount.toLocaleString("en-IN"),
      icon: <LuBuilding2 />,
      bg: "#eff6ff",
      color: "#2563eb",
      sub: "In the CRM",
      testId: "kpi-organizations",
    },
    {
      title: "Total Deal Value",
      val: dealValueDisplay,
      icon: <LuIndianRupee />,
      bg: "#ecfdf5",
      color: "#059669",
      sub: `Total Deals: ${dealsCount}`,
      testId: "kpi-deal-value",
    },
    {
      title: "Renewal Revenue",
      val: formatCompact(revRevenue),
      icon: <LuRotateCw />,
      bg: "#f5f3ff",
      color: "#7c3aed",
      sub: renewalSub,
      testId: "kpi-total-leads",
    },
  ];

  if (loading && !kpis?.total_organizations && totalOrganizations === 0) {
    return (
      <section className="kpis" data-testid="kpis-container">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={`kpi-skel-${i}`} className="card kpi skeleton-box" style={{ height: "115px" }} />
        ))}
      </section>
    );
  }

  return (
    <section className="kpis" id="kpiContainer" data-testid="kpis-container">
      {cards.map((c, i) => (
        <div className="card kpi" key={i} data-testid={c.testId}>
          <div className="kpi-top">
            <div>
              <div className="kpi-label">{c.title}</div>
              <div className="kpi-val">{c.val}</div>
            </div>
            <div className="kpi-icon" style={{ background: c.bg, color: c.color }}>
              {c.icon}
            </div>
          </div>
          <div className="kpi-sub">{c.sub}</div>
        </div>
      ))}
    </section>
  );
}
